import React from 'react'
import styled from 'styled-components'

const DefaultPageBlock = () => {
  const Div = styled.div`
    height: 100vh;
    width: 100%;
    color: #fff;
    background-color: #000;
    font-size: 2rem;
    padding: 1.875rem;
    padding-top: 30%;

    @media (min-width: 768px) {
      font-size: 5rem;
    }
  `

  return <Div>Default component</Div>
}

export default DefaultPageBlock
